/**
 * Generic notification helper.
 *
 * Exposes two globals so any feature/section can reuse the same logic
 * instead of redefining a `showMessage` function in every file.
 *
 *   showMessage(target, message, type)
 *   hideMessage(target)
 *
 * `target` can be either a DOM element or a CSS selector string.
 * `type`   is an optional state class (e.g. "success", "error",
 *          "info", "warning") that is added to the target element so
 *          existing per-feature CSS keeps working.
 */
(function (global) {
    var STATE_CLASSES = ["success", "error", "info", "warning"];

    function resolveTarget(target) {
        if (!target) return null;
        return typeof target === "string"
            ? document.querySelector(target)
            : target;
    }

    function showMessage(target, message, type) {
        var el = resolveTarget(target);
        if (!el) return;

        el.innerText = message == null ? "" : message;

        // Reset previous state classes so the element can switch types cleanly.
        el.classList.remove.apply(el.classList, STATE_CLASSES);
        el.classList.remove("hidden");

        if (type) el.classList.add(type);

        el.style.display = "block";
    }

    function hideMessage(target) {
        var el = resolveTarget(target);
        if (!el) return;

        el.innerText = "";
        el.classList.remove.apply(el.classList, STATE_CLASSES);
        el.style.display = "none";
    }

    global.showMessage = showMessage;
    global.hideMessage = hideMessage;
})(window);
